export default __webpack_public_path__ + "1682c812442f570cb6d7e102ea56b677.png";